import { baseApi, Http, rtkq, RtkqRequest } from '@app/base';

export const connectionsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    addConnectionWithProvider: build.mutation<string, RtkqRequest<{ providerId: string }>>({
      queryFn: rtkq.axios((args) => Http.post(`/api/connection/provider`, args)),
      invalidatesTags: (_, __, { providerId }) => {
        return [
          { type: 'main:employee', id: providerId },
          { type: 'main:employee', id: 'list' },
        ];
      },
    }),
    addConnectionWithPatient: build.mutation<string, RtkqRequest<{ patientId: string }>>({
      queryFn: rtkq.axios((args) => Http.post(`/api/connection/patient`, args)),
      invalidatesTags: (_, __, { patientId }) => {
        return [
          { type: 'main:patient', id: patientId },
          { type: 'main:patient', id: 'list' },
        ];
      },
    }),
  }),
});

export const { useAddConnectionWithProviderMutation, useAddConnectionWithPatientMutation } = connectionsApi;
